import { render, staticRenderFns } from "./FormPrincipalEmployee.vue?vue&type=template&id=460c7dda"
import script from "./FormPrincipalEmployee.vue?vue&type=script&lang=js"
export * from "./FormPrincipalEmployee.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalEmployee.vue?vue&type=style&index=0&id=460c7dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports